export const StatCard = ({ label, value, sub, icon: Icon, accent = "text-indigo-400", testid, delay = "" }) => (
  <div
    data-testid={testid}
    className={`sv-rise ${delay} rounded-lg border border-[#242C3D] bg-[#141A24]/80 p-6 hover:border-indigo-500/40 transition-colors duration-300`}
  >
    <div className="flex items-center justify-between mb-6">
      <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">{label}</span>
      {Icon && <Icon className={`w-4 h-4 ${accent}`} />}
    </div>
    <div className="font-mono text-3xl font-bold tracking-tight text-slate-50" data-testid={`${testid}-value`}>{value}</div>
    {sub && <div className="text-xs text-slate-500 mt-2">{sub}</div>}
  </div>
);
